export const profession = [
  {value: 1, label: 'Healthcare'},
  {value: 1, label: 'Corporate'},
  {value: 1, label: 'Education'},
  {value: 1, label: 'Finance'},
  {value: 1, label: 'Trades'},
  {value: 1, label: 'Retail'},
  {value: 1, label: 'Hospitality'},
  {value: 1, label: 'Business'},
  {value: 1, label: 'Transportation'},
  {value: 1, label: 'Media and Entertainment'},
  {value: 1, label: 'Government'},
  {value: 1, label: 'Legal'},
  {value: 1, label: 'Real Estate'},
  {value: 1, label: 'Agriculture'},
  {value: 1, label: 'Other'},
]

export const transactionType = [
  {value: 'all', label: 'All transaction types'},
  {value: 'driver_earning', label: 'Trip earnings'},
  {value: 'trip_expense', label: 'Trip expenses'},
  {value: 'credit_purchase', label: 'Credit purchase'},
  {value: 'passenger_payment', label: 'Passenger payment (combined)'},
  {value: 'referral', label: 'Social referral bonus'},
  {value: 'redeem', label: 'Gift card claim'},
  {value: 'welcome_credit', label: 'Welcome credit'},
  {value: 'other_debit', label: 'Other debit'},
]
